<template>
  <v-dialog
    v-model="dataInited"
    ref="dialog"
    fullscreen
    persistent
    :retain-focus="false"
    @keydown.esc="close(false)"
  >
    <v-card>
      <v-stepper v-model="stepper" class="elevation-0">
        <v-toolbar
          color="primaryBgr"
          dark
        >
          <v-row>
            <v-col cols="6" md="4">
              <div class="d-flex align-center p-h-100">
                <v-btn class="ml-n3 mr-5" tabindex="4" icon dark @click="close(false)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ $t('contact.merge.title') }}</v-toolbar-title>
              </div>
            </v-col>
            <v-col cols="6" md="4">
              <v-stepper-header class="elevation-0 p-dialog-steps-header theme--light">
                <v-stepper-step step="1">{{ $t('contact.merge.step1') }}</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2">{{ $t('contact.merge.step2') }}</v-stepper-step>
              </v-stepper-header>
            </v-col>
          </v-row>
        </v-toolbar>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-container>
              <v-row justify="space-between" class="flex-column flex-lg-row-reverse">
                <v-col cols="3" sm="12" md="12" lg="3" xl="3" class="p-merg-selected-block">
                  <h4 class="my-2 p-merg-selected-block-header">{{ $t('contact.merge.mergingContactsListTitle') }}</h4>
                  <v-data-table
                    :headers="tableHeadersMerging"
                    :items="contactsTableItemsMerging"
                    no-data-text=""
                    class="p-no-borders"
                    hide-default-header
                    hide-default-footer
                    disable-pagination
                  >
                    <template v-slot:[`item.displayName`]="{ item }">
                      <p-contact-item
                        :contact="item"
                        class="px-0"
                        font-bold
                      ></p-contact-item>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <div class="p-table-row-actions">
                        <p-btn-icon type="remove" class="mx-2" @click="onRemoveFromTableMerging(item)"></p-btn-icon>
                      </div>
                    </template>
                  </v-data-table>
                  <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-btn
                            v-on="on"
                            :disabled="btnNextDisabled"
                            class="p-btn-rounded mt-8"
                            color="primary"
                            large
                            rounded
                            dark
                            @click="gotoStep2"
                          >
                            {{ $t('next') }}
                          </v-btn>
                        </div>
                      </template>
                      <span v-if="btnNextDisabled">{{ $t('contact.merge.btnNextTooltipDisabled') }}</span>
                      <span v-else>{{ $t('contact.merge.btnNextTooltipEnabled')  }}</span>
                    </v-tooltip>
                </v-col>
                <v-col cols="8" sm="12" md="12" lg="8" xl="8">
                  <v-col class="p-toolbar">
                    <div class="p-toolbar-item p-search">
                      <p-search-input
                        v-model="search"
                        :items="searchSuggestions"
                        :slim-mode="true"
                        @submit="searchContacts"
                      ></p-search-input>
                    </div>
                  </v-col>
                  <v-data-table
                    :headers="tableHeaders"
                    :items="contactsTableItemsForMergeMapped"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    :server-items-length="contactsTableTotalCountForMerge"
                    :loading="!contactsLoaded"
                    no-data-text=""
                    hide-default-footer
                    class="p-no-borders"
                    @page-count="pageCount = $event"
                    @update:page="reloadContacts"
                  >
                    <template
                      v-slot:progress
                    >
                      <v-progress-linear
                        :height="2"
                        color="blue"
                        indeterminate
                      ></v-progress-linear>
                    </template>
                    <template v-slot:[`body.prepend`]>
                      <template v-if="duplicatesTableItemsMapped && duplicatesTableItemsMapped.length">
                        <tr class="p-tr-no-hover-background">
                          <td colspan="100%" class="font-weight-bold">{{ $t('contact.table.duplicatesTitle') }}</td>
                        </tr>
                        <tr v-for="item in duplicatesTableItemsMapped" :key="`duplicate-${item.id}`">
                          <td>
                            <v-checkbox
                              v-model="item.merge"
                              :hide-details="true"
                              class="mx-2 my-0"
                              dense
                              @change="onMergeCheckboxChange(item)"
                            >
                            </v-checkbox>
                          </td>
                          <td>
                            <p-contact-item
                              :contact="item"
                              :is-display-name-with-company="false"
                              class="px-0"
                              font-bold
                            ></p-contact-item>
                          </td>
                          <td>
                            <span class="text-no-wrap">
                              {{ item.company }}
                            </span>
                          </td>
                          <td>
                            <span class="text-no-wrap">
                              {{ item.displayEmail }}
                            </span>
                          </td>
                          <td>
                            <span class="text-no-wrap">
                              {{ item.displayPhone }}
                            </span>
                          </td>
                          <td>
                            <span class="text-no-wrap">
                              {{ item.fullAddress }}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="100%" class="p-tr-border-thin"></td>
                        </tr>
                      </template>
                    </template>
                    <template v-slot:[`item.merge`]="{ item }">
                      <v-checkbox
                        v-model="item.merge"
                        :hide-details="true"
                        class="mx-2 my-0"
                        dense
                        @change="onMergeCheckboxChange(item)"
                      >
                      </v-checkbox>
                    </template>
                    <template v-slot:[`item.displayName`]="{ item }">
                      <p-contact-item
                        :contact="item"
                        :is-display-name-with-company="false"
                        class="px-0"
                        font-bold
                      ></p-contact-item>
                    </template>
                    <template v-slot:[`item.displayEmail`]="{ item }">
                      <span class="text-no-wrap">
                        {{ item.displayEmail }}
                      </span>
                    </template>
                    <template v-slot:[`item.displayPhones`]="{ item }">
                      <div class="my-2">
                        <p v-for="(phone, index) in item.displayPhones" :key="`phone-${index}`" class="my-1 text-no-wrap">
                          {{ phone }}
                        </p>
                      </div>
                    </template>
                  </v-data-table>
                  <v-pagination
                    v-if="pageCount > 0"
                    v-model="page"
                    :length="pageCount"
                    :total-visible="15"
                    class="mt-10"
                  ></v-pagination>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-container>
              <v-row justify="center">
                <v-col cols="12" sm="12" md="10" lg="8" xl="4">
                  <v-form ref="form" @submit.stop.prevent>
                    <v-row class="mt-2">
                      <v-col sm="6">
                        <p-combobox
                          v-if="mergingContactsValues.firstName && mergingContactsValues.firstName.length > 1"
                          v-model.trim="mergedContact.firstName"
                          :items="mergingContactsValues.firstName"
                          :label="$t('contact.edit.firstName')"
                          :hide-details="inputHideDetails"
                          :rules="rules.firstName"
                          prepend-icon="mdi-account-outline"
                          tabindex="1"
                          clearable
                          autofocus
                          @input="triggerFormValidation"
                        />
                        <v-text-field
                          v-else
                          type="text"
                          v-model.trim="mergedContact.firstName"
                          :label="$t('contact.edit.firstName')"
                          :hide-details="inputHideDetails"
                          :rules="rules.firstName"
                          prepend-icon="mdi-account-outline"
                          autocomplete="off"
                          tabindex="1"
                          clearable
                          autofocus
                          @input="triggerFormValidation"
                        />
                      </v-col>
                      <v-col sm="6">
                        <p-combobox
                          v-if="mergingContactsValues.lastName && mergingContactsValues.lastName.length > 1"
                          v-model.trim="mergedContact.lastName"
                          :items="mergingContactsValues.lastName"
                          :label="$t('contact.edit.lastName')"
                          :hide-details="inputHideDetails"
                          :rules="rules.lastName"
                          tabindex="1"
                          clearable
                          @input="triggerFormValidation"
                        />
                        <v-text-field
                          v-else
                          type="text"
                          v-model.trim="mergedContact.lastName"
                          :label="$t('contact.edit.lastName')"
                          :hide-details="inputHideDetails"
                          :rules="rules.lastName"
                          autocomplete="off"
                          tabindex="1"
                          clearable
                          @input="triggerFormValidation"
                        />
                      </v-col>
                    </v-row>

                    <v-row class="mt-2 pl-9">
                      <v-col sm="12">
                        <p-combobox
                          v-if="mergingContactsValues.socialSecurityNumber && mergingContactsValues.socialSecurityNumber.length > 1"
                          v-model.trim="mergedContact.socialSecurityNumber"
                          :items="mergingContactsValues.socialSecurityNumber"
                          :label="$t('contact.edit.socialSecurityNumber')"
                          :hide-details="inputHideDetails"
                          :rules="rules.socialSecurityNumber"
                          tabindex="1"
                          validate-on-blur
                          clearable
                        />
                        <v-text-field
                          v-else
                          type="text"
                          v-model.trim="mergedContact.socialSecurityNumber"
                          :label="$t('contact.edit.socialSecurityNumber')"
                          :hide-details="inputHideDetails"
                          :rules="rules.socialSecurityNumber"
                          autocomplete="off"
                          tabindex="1"
                          validate-on-blur
                          clearable
                        />
                      </v-col>
                    </v-row>

                    <v-row class="mt-2">
                      <v-col cols="12">
                        <p-combobox
                          v-if="mergingContactsValues.company && mergingContactsValues.company.length > 1"
                          v-model.trim="mergedContact.company"
                          :items="mergingContactsValues.company"
                          :rules="rules.company"
                          :label="$t('contact.edit.company')"
                          :hide-details="inputHideDetails"
                          prepend-icon="mdi-domain"
                          tabindex="1"
                          clearable
                          @input="triggerFormValidation"
                        />
                        <v-text-field
                          v-else
                          v-model.trim="mergedContact.company"
                          :label="$t('contact.edit.company')"
                          :hide-details="inputHideDetails"
                          :rules="rules.company"
                          prepend-icon="mdi-domain"
                          type="text"
                          autocomplete="off"
                          tabindex="1"
                          />
                      </v-col>
                    </v-row>

                    <v-row class="mt-2 pl-9">
                      <v-col cols="12">
                        <p-combobox
                          v-if="mergingContactsValues.organisationNumber && mergingContactsValues.organisationNumber.length > 1"
                          v-model.trim="mergedContact.organisationNumber"
                          :items="mergingContactsValues.organisationNumber"
                          :label="$t('contact.edit.organisationNumber')"
                          :hide-details="inputHideDetails"
                          :rules="rules.organisationNumber"
                          tabindex="1"
                          validate-on-blur
                          clearable
                        />
                        <v-text-field
                          v-else
                          type="text"
                          v-model.trim="mergedContact.organisationNumber"
                          :label="$t('contact.edit.organisationNumber')"
                          :hide-details="inputHideDetails"
                          :rules="rules.organisationNumber"
                          autocomplete="off"
                          tabindex="1"
                          validate-on-blur
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="mergedContact.email" class="mt-2 email-row" id="email-row">
                      <v-col cols="8">
                        <p-combobox
                          v-if="mergingContactsValues.email.email && mergingContactsValues.email.email.length > 1"
                          v-model.trim="mergedContact.email.email"
                          :items="mergingContactsValues.email.email"
                          :label="$t('contact.edit.email')"
                          :hide-details="inputHideDetails"
                          :rules="rules.email"
                          prepend-icon="mdi-email-outline"
                          tabindex="1"
                          validate-on-blur
                          clearable
                        />
                        <v-text-field
                          v-else
                          type="text"
                          v-model.trim="mergedContact.email.email"
                          :label="$t('contact.edit.email')"
                          :hide-details="inputHideDetails"
                          :rules="rules.email"
                          prepend-icon="mdi-email-outline"
                          autocomplete="off"
                          tabindex="1"
                          validate-on-blur
                          clearable
                        />
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="mergedContact.email.emailType"
                          :items="emailTypes"
                          :placeholder="$t('contact.edit.emailType')"
                          :hide-details="inputHideDetails"
                          item-text="name"
                          item-value="id"
                          tabindex="1"
                          return-object
                        ></v-select>
                      </v-col>
                    </v-row>

                    <div class="p-contact-merge__row">
                      <div class="p-contact-merge__icon-col">
                        <v-icon>mdi-phone-outline</v-icon>
                      </div>
                      <div class="p-contact-merge__fields-col">
                        <v-row v-for="(phone, index) in phones" :key="`phone-${index}`">
                          <v-col cols="8" class="p-contact-merge__fields-col__text-field">
                            <v-text-field
                              type="text"
                              v-model.trim="phone.phone"
                              :label="$t('contact.edit.phone')"
                              hide-details="auto"
                              tabindex="1"
                              clearable
                              @input="onPhoneInput"
                              @blur="onPhoneBlur"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4" class="p-contact-merge__fields-col__select">
                            <v-select
                              v-model="phone.phoneType"
                              :items="phoneTypes"
                              :placeholder="$t('contact.edit.phoneType')"
                              hide-details="auto"
                              item-text="name"
                              item-value="id"
                              tabindex="1"
                              return-object
                            ></v-select>
                          </v-col>
                        </v-row>
                      </div>
                    </div>

                    <v-row class="mt-2">
                      <v-col cols="12">
                        <p-combobox
                          v-model="mergedContact.labels"
                          :items="contactLabels"
                          :label="$t('contact.edit.labels')"
                          :hide-details="inputHideDetails"
                          item-value="id"
                          item-text="name"
                          prepend-icon="mdi-label-outline"
                          tabindex="1"
                          multiple
                          small-chips
                          deletable-chips
                          hide-selected
                          clearable
                          @keypress.enter.stop
                        ></p-combobox>
                      </v-col>
                    </v-row>

                    <v-row class="mt-1">
                      <v-col cols="12">
                        <p-combobox
                          v-if="mergingContactsValues.note && mergingContactsValues.note.length > 1"
                          v-model.trim="mergedContact.note"
                          :items="mergingContactsValues.note"
                          :label="$t('contact.edit.note')"
                          :hide-details="inputHideDetails"
                          prepend-icon="mdi-note-outline"
                          tabindex="1"
                          clearable
                        />
                        <v-text-field
                          v-else
                          type="text"
                          v-model.trim="mergedContact.note"
                          :label="$t('contact.edit.note')"
                          :hide-details="inputHideDetails"
                          prepend-icon="mdi-note-outline"
                          autocomplete="off"
                          tabindex="1"
                          clearable
                        />
                      </v-col>
                    </v-row>

                    <v-row class="mt-1">
                      <v-col cols="12">
                        <p-combobox
                          v-if="mergingContactsValues.iceName && mergingContactsValues.iceName.length > 1"
                          v-model.trim="mergedContact.iceName"
                          :items="mergingContactsValues.iceName"
                          :label="$t('contact.edit.iceName')"
                          :hide-details="inputHideDetails"
                          prepend-icon="mdi-card-account-phone-outline"
                          tabindex="1"
                          clearable
                        />
                        <v-text-field
                          v-else
                          type="text"
                          v-model.trim="mergedContact.iceName"
                          :label="$t('contact.edit.iceName')"
                          :hide-details="inputHideDetails"
                          prepend-icon="mdi-card-account-phone-outline"
                          autocomplete="off"
                          tabindex="1"
                          clearable
                        />
                      </v-col>
                    </v-row>

                    <v-row class="mt-1">
                      <v-col cols="12">
                        <p-combobox
                          v-if="mergingContactsValues.icePhone && mergingContactsValues.icePhone.length > 1"
                          v-model.trim="mergedContact.icePhone"
                          :items="mergingContactsValues.icePhone"
                          :label="$t('contact.edit.icePhone')"
                          :hide-details="inputHideDetails"
                          prepend-icon="mdi-card-account-phone-outline"
                          tabindex="1"
                          clearable
                        />
                        <v-text-field
                          v-else
                          type="text"
                          v-model.trim="mergedContact.icePhone"
                          :label="$t('contact.edit.icePhone')"
                          :hide-details="inputHideDetails"
                          prepend-icon="mdi-card-account-phone-outline"
                          autocomplete="off"
                          tabindex="1"
                          clearable
                        />
                      </v-col>
                    </v-row>

                    <v-row class="mt-1">
                      <v-col cols="12">
                        <p-combobox
                          v-if="mergingContactsValues.bonusProgram && mergingContactsValues.bonusProgram.length > 1"
                          v-model.trim="mergedContact.bonusProgram"
                          :items="mergingContactsValues.bonusProgram"
                          :label="$t('contact.edit.bonusProgram')"
                          :hide-details="inputHideDetails"
                          prepend-icon="mdi-gift-outline"
                          tabindex="1"
                          clearable
                        />
                        <v-text-field
                          v-else
                          type="text"
                          v-model.trim="mergedContact.bonusProgram"
                          :label="$t('contact.edit.bonusProgram')"
                          :hide-details="inputHideDetails"
                          prepend-icon="mdi-gift-outline"
                          autocomplete="off"
                          tabindex="1"
                          clearable
                        />
                      </v-col>
                    </v-row>

                    <v-row v-if="mergedContact.address" class="mt-2">
                      <v-col cols="8">
                        <p-combobox
                          v-model="mergedContact.address.country"
                          :items="countries"
                          :label="$t('contact.edit.country')"
                          :hide-details="inputHideDetails"
                          item-value="id"
                          item-text="name"
                          prepend-icon="mdi-map-marker-outline"
                          tabindex="1"
                          hide-selected
                          return-object
                          clearable
                        ></p-combobox>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="mergedContact.address.addressType"
                          :items="addressTypes"
                          :placeholder="$t('contact.edit.addressType')"
                          :hide-details="inputHideDetails"
                          item-text="name"
                          item-value="id"
                          tabindex="1"
                          return-object
                        ></v-select>
                      </v-col>

                      <v-col cols="12" class="mt-2 pl-12">
                        <p-combobox
                          v-if="mergingContactsValues.address.addressline1 && mergingContactsValues.address.addressline1.length > 1"
                          v-model.trim="mergedContact.address.addressline1"
                          :items="mergingContactsValues.address.addressline1"
                          :label="$t('contact.edit.addressLine1')"
                          :hide-details="inputHideDetails"
                          tabindex="1"
                          clearable
                        ></p-combobox>
                        <v-text-field
                          v-else
                          v-model.trim="mergedContact.address.addressline1"
                          :label="$t('contact.edit.addressLine1')"
                          :hide-details="inputHideDetails"
                          type="text"
                          autocomplete="off"
                          tabindex="1"
                          clearable
                        />
                      </v-col>

                      <v-col cols="12" class="mt-2 pl-12">
                        <p-combobox
                          v-if="mergingContactsValues.address.addressline2 && mergingContactsValues.address.addressline2.length > 1"
                          v-model.trim="mergedContact.address.addressline2"
                          :items="mergingContactsValues.address.addressline2"
                          :label="$t('contact.edit.addressLine2')"
                          :hide-details="inputHideDetails"
                          tabindex="1"
                          clearable
                        ></p-combobox>
                        <v-text-field
                          v-else
                          v-model.trim="mergedContact.address.addressline2"
                          :label="$t('contact.edit.addressLine2')"
                          :hide-details="inputHideDetails"
                          type="text"
                          autocomplete="off"
                          tabindex="1"
                          clearable
                        />
                      </v-col>

                      <v-col cols="12" class="mt-2 pl-12">
                        <p-combobox
                          v-if="mergingContactsValues.address.city && mergingContactsValues.address.city.length > 1"
                          v-model.trim="mergedContact.address.city"
                          :items="mergingContactsValues.address.city"
                          :label="$t('contact.edit.city')"
                          :hide-details="inputHideDetails"
                          tabindex="1"
                          clearable
                        ></p-combobox>
                        <v-text-field
                          v-else
                          v-model.trim="mergedContact.address.city"
                          :label="$t('contact.edit.city')"
                          :hide-details="inputHideDetails"
                          type="text"
                          autocomplete="off"
                          tabindex="1"
                          clearable
                        />
                      </v-col>

                      <v-col cols="12" class="mt-2 pl-12">
                        <p-combobox
                          v-if="mergingContactsValues.address.stateProvinceRegion && mergingContactsValues.address.stateProvinceRegion.length > 1"
                          v-model.trim="mergedContact.address.stateProvinceRegion"
                          :items="mergingContactsValues.address.stateProvinceRegion"
                          :label="$t('contact.edit.stateProvinceRegion')"
                          :hide-details="inputHideDetails"
                          tabindex="1"
                          clearable
                        ></p-combobox>
                        <v-text-field
                          v-else
                          v-model.trim="mergedContact.address.stateProvinceRegion"
                          :label="$t('contact.edit.stateProvinceRegion')"
                          :hide-details="inputHideDetails"
                          type="text"
                          autocomplete="off"
                          tabindex="1"
                          clearable
                        />
                      </v-col>

                      <v-col cols="12" class="mt-2 pl-12">
                        <p-combobox
                          v-if="mergingContactsValues.address.zipCode && mergingContactsValues.address.zipCode.length > 1"
                          v-model.trim="mergedContact.address.zipCode"
                          :items="mergingContactsValues.address.zipCode"
                          :label="$t('contact.edit.zipCode')"
                          :hide-details="inputHideDetails"
                          tabindex="1"
                          clearable
                        ></p-combobox>
                        <v-text-field
                          v-else
                          v-model.trim="mergedContact.address.zipCode"
                          :label="$t('contact.edit.zipCode')"
                          :hide-details="inputHideDetails"
                          type="text"
                          autocomplete="off"
                          tabindex="1"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                  <div class="d-flex mt-8 justify-center">
                    <v-btn
                      class="p-btn-text mx-4"
                      color="primary"
                      tabindex="3"
                      text
                      large
                      @click="gotoStep1"
                    >
                      {{ $t('back') }}
                    </v-btn>
                    <v-btn
                      class="p-btn-rounded mx-4"
                      color="primary"
                      tabindex="2"
                      large
                      rounded
                      dark
                      @click="submit"
                    >
                      {{ $t('save') }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>


<script>
import eventBus from '@/eventBus'

import { mapActions, mapGetters, mapState } from 'vuex'

import { contactSchema } from '@/constants'

import PContactItem from '@/components/PContactItem'
import PSearchInput from '@/components/PSearchInput'
import PBtnIcon from '@/components/PBtnIcon'
import PCombobox from '@/components/PCombobox'

import snackbarMixin from '@/mixins/snackbar.mixin'
import objectMixin from '@/mixins/object.mixin'
import dialogMixin from '@/mixins/dialog.mixin'
import validationMixin from '@/mixins/validation.mixin'


export default {
  components: {
    PContactItem,
    PSearchInput,
    PBtnIcon,
    PCombobox
  },


  mixins: [
    snackbarMixin,
    objectMixin,
    dialogMixin,
    validationMixin
  ],


  props: {
    contact: Object
  },


  data () {
    return {
      dataInited: false,
      contactsLoaded: false,
      stepper: 1,
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      contactsTableItemsMerging: [],
      inputHideDetails: 'auto',
      validateDisplayName: false,
      existingEmails: [],
      rule: {
        displayNameRequired: message => {
          return value => {
            message = message || ' '
            const isValid = !!this.mergedContact.firstName || !!this.mergedContact.lastName || !!this.mergedContact.company
            return !this.validateDisplayName || isValid || message
          }
        },
        emailExists: value => {
          return !value || !this.existingEmails.includes(value) || this.$t('contact.emailExists')
        }
      },
      duplicates: {},
      mergingContactsList: [],
      mergingContactsValues: {},
      mergedContact: {},
      phones: [],
      newPhone: {}
    }
  },


  computed: {
    ...mapState('country', ['countries']),
    ...mapState('contact', ['addressTypes', 'phoneTypes', 'emailTypes']),
    ...mapGetters('contact', ['shortContacts', 'contactsTableItemsForMerge', 'contactsTableTotalCountForMerge', 'duplicatesTableItems', 'duplicatesTableTotalCount']),
    ...mapGetters('contactLabel', ['contactLabels', 'contactLabelById']),

    defaultContact () {
      return {
        firstName: '',
        lastName: '',
        socialSecurityNumber: '',
        company: '',
        organisationNumber: '',
        address: {
          id: '',
          addressline1: '',
          addressline2: '',
          city: '',
          stateProvinceRegion: '',
          zipCode: '',
          country: this.countries[0],
          isPrimary: true,
          addressType: this.addressTypes[0]
        },
        email: {
          id: '',
          email: '',
          isPrimary: true,
          emailType: this.emailTypes[0]
        },
        phones: [{
          id: '',
          phone: '',
          isPrimary: true,
          phoneType: this.phoneTypes[0]
        }],
        labels: [],
        note: '',
        isActive: true,
        iceName: null,
        icePhone: null,
        bonusProgram: ''
      }
    },

    defaultNewPhone () {
      return {
        id: '',
        phone: '',
        isPrimary: false,
        phoneType: this.phoneTypes[0]
      }
    },

    mergeInterface () {
      return {
        id: '',
        firstName: '',
        lastName: '',
        socialSecurityNumber: '',
        company: '',
        organisationNumber: '',
        displayName: '',
        address: {
          id: '',
          addressline1: '',
          addressline2: '',
          city: '',
          stateProvinceRegion: '',
          zipCode: '',
          country: this.countries[0],
          isPrimary: true,
          addressType: this.addressTypes[0]
        },
        fullAddress: '',
        email: {
          id: '',
          email: '',
          isPrimary: true,
          emailType: this.emailTypes[0]
        },
        note: '',
        isActive: true,
        iceName: null,
        icePhone: null,
        bonusProgram: '',
        color: '',
        userId: '',
        labels: [],
        duplicates: []
      }
    },

    btnNextDisabled () {
      return this.contactsTableItemsMerging && this.contactsTableItemsMerging.length < 2
    },

    contactsTableItemsForMergeMapped () {
      return this.contactsTableItemsForMerge.map(el => {
        const merge = this.isInContactsTableItemsMergingById(el.id)
        return {
          ...el,
          merge
        }
      })
    },

    duplicatesTableItemsMapped () {
      return this.duplicatesTableItems.map(el => {
        const merge = this.isInContactsTableItemsMergingById(el.id)
        return {
          ...el,
          merge
        }
      })
    },

    tableHeadersMerging () {
      return [
        { text: this.$t('contact.table.name'), value: 'displayName', sortable: false },
        { text: '', value: 'actions', align: 'start', sortable: false, filterable: false }
      ]
    },

    tableHeaders () {
      return [
        { text: this.$t('contact.table.merge'), value: 'merge', sortable: false },
        { text: this.$t('contact.table.name'), value: 'displayName', sortable: false },
        { text: this.$t('contact.table.company'), value: 'company', sortable: false },
        { text: this.$t('contact.table.emails'), value: 'displayEmail', sortable: false },
        { text: this.$t('contact.table.phones'), value: 'displayPhones', sortable: false },
        { text: this.$t('contact.table.address'), value: 'fullAddress', width: 300, sortable: false }
      ]
    },

    searchSuggestions () {
      const items = this.contactLabels.map(label => {
        return label.name
      })

      for (const contact of this.shortContacts) {
        if (contact.displayName && items.find(x => x === contact.displayName) == null) {
          items.push(contact.displayName)
        }
      }

      return items
    },

    rulesToApply () {
      const rule = this.rule

      return {
        firstName: [rule.displayNameRequired()],
        lastName: [rule.displayNameRequired()],
        socialSecurityNumber: [rule.maxLength(contactSchema.socialSecurityNumberMaxLength)],
        company: [rule.displayNameRequired(this.$t('validation.displayNameRequired'))],
        organisationNumber: [rule.maxLength(contactSchema.organisationNumberMaxLength)],
        email: [rule.email(), rule.emailExists]
      }
    }
  },


  watch: {
    dialog: function (value) {
      if (value === true) {
        this.validateDisplayName = false
        this.initData()
      }
    }
  },

  created () {
    try {
      this.loadAddressTypes()
      this.loadEmailTypes()
      this.loadPhoneTypes()
      this.loadCountries()
    } catch (error) {
      this.$log.error(error)
    }
  },


  methods: {
    ...mapActions('contact', ['loadContactsTableItemsForMerge', 'loadContactById', 'loadShortContacts', 'loadDuplicates', 'mergeContact', 'loadAddressTypes', 'loadEmailTypes', 'loadPhoneTypes']),
    ...mapActions('country', ['loadCountries']),
    ...mapActions('contactLabel', ['loadContactLabels']),

    onDialogOpen () {
      this.existingEmails = []
      this.validateDisplayName = false
      this.initData()
    },

    async initData () {
      try {
        this.dataInited = false
        this.contactsLoaded = false
        await Promise.all([
          this.loadDuplicates(this.contact.id),
          this.loadContactLabels(),
          this.loadContactsTableItemsForMerge({ take: this.itemsPerPage })
        ])
        this.dataInited = true
        this.contactsLoaded = true
        this.initContactsTableItemsMerging()
        this.gotoStep1()
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    },

    initContactsTableItemsMerging () {
      this.contactsTableItemsMerging = []
      this.contactsTableItemsMerging.push(this.contact)
    },

    gotoStep1 () {
      this.stepper = 1
      this.$nextTick(() => {
        this.resetValidation()
      })
    },

    async searchContacts (value) {
      await this.reloadContacts(1, value)
    },

    async reloadContacts (page, search) {
      try {
        this.page = page || this.page
        this.contactsLoaded = false
        await this.loadContactsTableItemsForMerge({
          skip: (this.page - 1) * this.itemsPerPage,
          take: this.itemsPerPage,
          search: search || this.search
        })
        this.contactsLoaded = true
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    },

    isInContactsTableItemsMergingById (id) {
      return !!this.contactsTableItemsMerging.filter(el => el.id === id).length
    },

    onMergeCheckboxChange (contact) {
      if (contact.merge) {
        this.contactsTableItemsMerging.push(contact)
      } else {
        this.contactsTableItemsMerging = this.contactsTableItemsMerging.filter(el => {
          return el.id !== contact.id
        })
      }
    },

    onRemoveFromTableMerging (contact) {
      this.contactsTableItemsMerging = this.contactsTableItemsMerging.filter(el => {
        return el.id !== contact.id
      })
    },

    gotoStep2 () {
      if (this.contactsTableItemsMerging.length < 2) {
        this.showSnackbarError(this.$t('contact.merge.errorNoMergingItems'))
        return
      }
      this.initMergingContactsValues()
      this.stepper = 2
    },

    initMergingContactsValues () {
      this.mergingContactsValues = {}
      const mergedContactProperties = this.getObjectCopy(this.contactsTableItemsMerging[0])
      this.mergedContact = {}
      const labels = []
      const emails = []
      this.phones = []

      this.mergingContactsValues.address = {}
      for (const subprop in this.defaultContact.address) {
        this.mergingContactsValues.address[subprop] = []
      }

      this.mergingContactsValues.email = {}
      for (const subprop in this.defaultContact.email) {
        this.mergingContactsValues.email[subprop] = []
      }

      for (const prop in mergedContactProperties) {
        if (prop !== 'labels' && prop !== 'address' && prop !== 'phones' && prop !== 'email') {
          this.mergingContactsValues[prop] = []
        }
        this.contactsTableItemsMerging.forEach(item => {
          const value = item[prop]

          if (prop === 'labels') {
            value.forEach(el => {
              if (labels.indexOf(el) === -1) {
                labels.push(el)
              }
            })
          } else if (prop === 'email' && value && value.email) {
            if (emails.indexOf(value.email) === -1) {
              emails.push(value.email)
            }
            for (const subprop in item[prop]) {
              const val = item[prop] ? item[prop][subprop] : null
              if (val && this.mergingContactsValues.email[subprop].indexOf(val) === -1) {
                this.mergingContactsValues.email[subprop].push(val)
              }
            }
          } else if (prop === 'phones') {
            value.forEach(phone => {
              if (!this.phones.filter(el => el.phone === phone.phone && el.phoneType.name === phone.phoneType.name).length) {
                this.phones.push(phone)
              }
            })
          } else if (prop === 'address') {
            for (const subprop in item[prop]) {
              const val = item[prop] ? item[prop][subprop] : null
              if (val && this.mergingContactsValues.address[subprop].indexOf(val) === -1) {
                this.mergingContactsValues.address[subprop].push(val)
              }
            }
          } else {
            if (value && this.mergingContactsValues[prop].indexOf(value) === -1) {
              this.mergingContactsValues[prop].push(value)
            }
          }
        })

        if (prop !== 'labels' && prop !== 'email' && prop !== 'phones' && prop !== 'address') {
          if (this.mergingContactsValues[prop].length) {
            this.mergedContact[prop] = this.mergingContactsValues[prop][0]
          } else {
            this.mergingContactsValues[prop].push(this.defaultContact[prop])
          }
        }
      }

      this.mergedContact.labels = labels.map(label => this.contactLabelById(label))

      this.mergedContact.email = this.defaultContact.email
      for (const subprop in this.defaultContact.email) {
        if (this.mergingContactsValues.email[subprop] && this.mergingContactsValues.email[subprop].length) {
          this.mergedContact.email[subprop] = this.mergingContactsValues.email[subprop].find(el => !!el)
        }
      }

      this.phones.push(this.getObjectCopy(this.defaultNewPhone))

      this.mergedContact.address = this.defaultContact.address
      for (const subprop in this.defaultContact.address) {
        if (this.mergingContactsValues.address[subprop] && this.mergingContactsValues.address[subprop].length) {
          this.mergedContact.address[subprop] = this.mergingContactsValues.address[subprop].find(el => !!el)
        }
      }
    },

    onPhoneInput (val) {
      if (val) {
        if (val.length === 1) {
          this.phones.push(this.getObjectCopy(this.defaultNewPhone))
        }
      } else {
        this.phones.forEach((phone, i) => {
          if (this.phones.length > 1 && i < this.phones.length - 1 && !phone.phone) {
            this.phones.splice(i, 1)
          }
        })
      }
    },

    onPhoneBlur (el) {
      this.phones.forEach((phone, i) => {
        if (this.phones.length > 1 && i < this.phones.length - 1 && !phone.phone) {
          this.phones.splice(i, 1)
        }
      })
    },

    handleLabelsChange () {
      this.$refs.labels.lazySearch = ''
      // remove from the array string only contain whitespace (ie. spaces, tabs or line breaks)
      this.mergedContact.labels = this.mergedContact.labels.filter((el) => {
        return !this.isFalseOrWhitespace(el)
      })
    },

    isObject (value) {
      return typeof value === 'object' && !Array.isArray(value) && value !== null
    },

    async triggerFormValidation () {
      await this.validate(this.rulesToApply)
    },

    async submit () {
      this.validateDisplayName = true

      const valid = await this.validate(this.rulesToApply)
      if (!valid) {
        this.scrollToFirstError()
        return
      }

      try {
        this.showSnackbarProcessing()
        const contact = this.getObjectCopy(this.mergeInterface)

        for (const prop in contact) {
          const value = this.mergedContact[prop]
          if (!this.isObject(value) && this.mergedContact[prop]) {
            contact[prop] = this.mergedContact[prop]
          }
        }

        for (const prop in contact.address) {
          if (this.mergedContact.address && this.mergedContact.address[prop]) {
            contact.address[prop] = this.mergedContact.address[prop]
          }
        }
        if (!contact.address.addressline1 &&
          !contact.address.addressline2 &&
          !contact.address.country &&
          !contact.address.city &&
          !contact.address.stateProvinceRegion &&
          !contact.address.zipCode) {
          contact.address = null
        }

        for (const prop in contact.email) {
          if (this.mergedContact.email && this.mergedContact.email[prop]) {
            contact.email[prop] = this.mergedContact.email[prop]
          }
        }
        if (!contact.email.email) {
          contact.email = null
        }
        if (contact.email && !contact.email.id) {
          delete contact.email.id
        }

        if (this.phones.length === 1 && !this.phones[0].phone) {
          contact.phones = null
        } else {
          contact.phones = []
          this.phones.forEach(phone => {
            if (phone.phone) {
              if (!phone.id) {
                delete phone.id
              }
              phone.isPrimary = false
              contact.phones.push(phone)
            }
          })
          contact.phones[0].isPrimary = true
        }

        const labels = []
        for (const label of this.mergedContact.labels) {
          if (typeof label === 'string') {
            labels.push({ name: label })
          } else {
            labels.push(label)
          }
        }
        contact.labels = labels

        contact.duplicates = [...this.contactsTableItemsMerging.filter(el => el.id !== this.mergedContact.id).map(el => el.id)]
        await this.mergeContact(contact)
        this.showSnackbarSuccess(this.$t('contact.merge.contactsMerged'))
        this.close(true)
        this.validateDisplayName = false
      } catch (error) {
        if (this.is409ConflictError(error)) {
          this.hideSnackbar()
          this.existingEmails.push(this.mergedContact.email.email)
          this.validate(this.rulesToApply)
          this.scrollToFirstError()
        } else {
          this.showSnackbarError()
        }
        this.$log.error(error)
      }
    },

    close (merged) {
      this.dataInited = false
      this.$emit('close', merged)
      eventBus.$emit('merged', merged)
    }
  }
}
</script>
